<h2 class="text-center" mat-dialog-title>{{ 'Intellitrailer.MyPage.Dialog.ImportBookingTtl' | translate : 'Import booking' }}</h2>

<div mat-dialog-content>

  @if (!nextClicked) {
  @if (loading) {
    <div class="spinner-container">
      <mat-spinner diameter="70"></mat-spinner>
    </div>
  } @else {
  @if (form) {
  <section>
    <p>{{'Intellitrailer.MyPage.Dialog.ImportBooking.Guide' |translate :'If you have made a booking on the web you can import it to the app using the 6 digit code found at the end of your booking confirmation email.'}}</p>
  </section>
  }
  }
  } @else {
  @if (loading) {
  <div class="spinner-container">
    <mat-spinner diameter="70"></mat-spinner>
  </div>
  } @else {
  @if(form) {
  <section align="center">
    <p>{{'Intellitrailer.MyPage.Dialog.ImportBooking.ExplanationSSNAndCode' | translate :'To import a booking made on the website, please type in your SSN and the 6 digit code found at the end of your booking confirmation email.'}}</p>

    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>{{'Intellitrailer.MyPage.Dialog.ImportBooking.txtPhone' | translate : 'Phone number (With country code)'}}</mat-label>
        <input matInput required formControlName="SSN" autocomplete="off" />
        @if(form.controls.SSN.invalid) {
        <mat-error>
          {{'Intellitrailer.MyPage.ValidateAccount.InvalidSSN' | translate : 'A valid phone number is required' }}
        </mat-error>
        }

      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>
          {{'Intellitrailer.MyPage.ValidateAccount.BookingNumber' | translate : 'Booking number' }}
        </mat-label>
        <input matInput required formControlName="BookingId" placeholder="XXXXXXXX" autocomplete="off" />
        @if(form.controls.BookingId.invalid) {
        <mat-error> {{ 'Intellitrailer.MyPage.ValidateAccount.InvalidCode' | translate : 'The code entered was invalid.' }} </mat-error>
        }
      </mat-form-field>
    </form>
  </section>
  }
  }
  }

</div>

<!-- Dialog Actions -->
<div mat-dialog-actions align="center">
  @if (!nextClicked) {
  <button mat-raised-button (click)="next()">
    {{ 'Intellitrailer.MyPage.Dialog.Next' | translate : 'Next' }}
  </button>
  } @else {
  <button mat-raised-button (click)="next()" [disabled]="form.invalid">
    {{ 'Intellitrailer.MyPage.Dialog.ImportTtl' | translate : 'Import' }}
  </button>
  <button mat-raised-button (click)="cancel()">
    {{ 'Intellitrailer.Booking.Dialog.FindLocationDialog.Cancel' | translate : 'Cancel' }}
  </button>
  }
</div>
